import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=380647ee&scoped=true"
import script from "./Pagination.ts?vue&type=script&lang=ts&external"
export * from "./Pagination.ts?vue&type=script&lang=ts&external"
import style0 from "./Pagination.scss?vue&type=style&index=0&id=380647ee&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380647ee",
  null
  
)

export default component.exports